export const CUSTOM_TYPE_TEXT = 1;
export const CUSTOM_TYPE_DATE = 2;
export const CUSTOM_TYPE_NUMBER = 3;
export const CUSTOM_TYPE_OPTIONS = 4;
export const CUSTOM_TYPE_CURRENCY = 5;
export const CUSTOM_TYPE_RATE_EXCHANGE = 6;

export const PERSONALIZADOS_QUE_NO_CAMBIA_TIPO = [
  CUSTOM_TYPE_RATE_EXCHANGE,
  CUSTOM_TYPE_OPTIONS,
  CUSTOM_TYPE_CURRENCY
];
export const CUSTOM_TYPES = [
  {
    valor: CUSTOM_TYPE_TEXT,
    label: 'Texto'
  },
  {
    valor: CUSTOM_TYPE_DATE,
    label: 'Fecha'
  },
  {
    valor: CUSTOM_TYPE_NUMBER,
    label: 'Numero'
  },
  {
    valor: CUSTOM_TYPE_OPTIONS,
    label: 'Opciones'
  },
  {
    valor: CUSTOM_TYPE_CURRENCY,
    label: 'Moneda'
  },
  {
    valor: CUSTOM_TYPE_RATE_EXCHANGE,
    label: 'Tasa de cambio'
  }
];

export const AVALAIBLE_CUSTOM_TYPES = [
  {
    valor: CUSTOM_TYPE_TEXT,
    label: 'Texto'
  },
  {
    valor: CUSTOM_TYPE_DATE,
    label: 'Fecha'
  },
  {
    valor: CUSTOM_TYPE_NUMBER,
    label: 'Número'
  }
];

export const DOCX_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword'
];
